import React from 'react';
import { Typography } from '@mui/material';
import {
  StyledBox,
  StyledBoxNotScrollable,
  StyledChip,
  StyledTypo2,
} from './Search.styled';
import CustomTooltip from '../../shared/tooltip/CustomTooltip';
import { InfoOutlined } from '@mui/icons-material';

type MapSearchResultProps = {
  caption: React.ReactNode;
  filteredData: string[];
  MAX_AMOUNT: number;
  handleAdd: (data: string) => void;
  handleRemove: (data: string) => void;
  selectedData: string[];
  toolTipText?: string;
  isScrollableDisplayed: boolean;
};

const mapSearchResult: React.FC<MapSearchResultProps> = ({
  caption,
  filteredData,
  MAX_AMOUNT,
  handleAdd,
  handleRemove,
  selectedData,
  toolTipText,
  isScrollableDisplayed,
}) => {
  return (
    <>
      <StyledTypo2 variant="caption">
        {caption}
        {toolTipText && (
          <CustomTooltip
            icon={<InfoOutlined sx={{ fontSize: '16px' }} />}
            title={toolTipText}
          />
        )}
      </StyledTypo2>
      {isScrollableDisplayed ? (
        <StyledBox>
          {filteredData.length > 0 ? (
            filteredData
              .slice(0, MAX_AMOUNT)
              .map((data) => (
                <StyledChip
                  key={data}
                  label={data}
                  onClick={() => handleAdd(data)}
                  color={selectedData.includes(data) ? 'primary' : 'default'}
                  variant={selectedData.includes(data) ? 'filled' : 'outlined'}
                  onDelete={
                    selectedData.includes(data)
                      ? () => handleRemove(data)
                      : undefined
                  }
                />
              ))
          ) : (
            <Typography variant="subtitle2" color="text.disabled">
              No result for your search
            </Typography>
          )}
          {filteredData.length > MAX_AMOUNT && (
            <StyledChip
              label={`... ${filteredData.length - MAX_AMOUNT} more`}
              color="default"
              variant="outlined"
            />
          )}
        </StyledBox>
      ) : (
        <StyledBoxNotScrollable>
          {filteredData.length > 0 ? (
            filteredData
              .slice(0, MAX_AMOUNT)
              .map((data) => (
                <StyledChip
                  key={data}
                  label={data}
                  onClick={() => handleAdd(data)}
                  color={selectedData.includes(data) ? 'primary' : 'default'}
                  variant={selectedData.includes(data) ? 'filled' : 'outlined'}
                  onDelete={
                    selectedData.includes(data)
                      ? () => handleRemove(data)
                      : undefined
                  }
                />
              ))
          ) : (
            <Typography variant="subtitle2" color="text.disabled">
              No result for your search
            </Typography>
          )}
          {filteredData.length > MAX_AMOUNT && (
            <StyledChip
              label={`... ${filteredData.length - MAX_AMOUNT} more`}
              color="default"
              variant="outlined"
            />
          )}
        </StyledBoxNotScrollable>
      )}
    </>
  );
};

export default mapSearchResult;
